import { ComponentType } from '@angular/cdk/portal';
import { ISnackbarBase } from './snackbar-base.model';

export class ModelSnackBarNotificationRequestData implements ISnackbarBase {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    componentRef: ComponentType<any>;
    
    callbackOnAction: ((response?: boolean) => void) | undefined;

    data = "Would you like to receive notifications for this campaign?";

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(componentRef: ComponentType<any>, callbackOnAction?: (response?: any) => void, notificationRequest?: string) {
        this.componentRef = componentRef;
        this.callbackOnAction = callbackOnAction;
        this.data = notificationRequest || this.data;
    }
}
